var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-frame page-article-frame"},[_c('iframe',{staticClass:"article-frame__iframe",attrs:{"src":_vm.iframeSrc,"frameborder":"0","title":"图文内容"}})])}
var staticRenderFns = []

export { render, staticRenderFns }